module.exports = __webpack_public_path__ + "static/media/item_2_4ll.2db6e98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_4ll.png
// module id = 121
// module chunks = 0